import Axios from 'axios'
import {holidayUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_holidays (context) {
    Axios.get(holidayUrls.getAllHolidays).then(function (response) {
      context.commit('GET_ALL_HOLIDAYS', response.data)
    })
  },
  get_holidays (context, publicId) {
    Axios.get(holidayUrls.getHolidays + publicId).then(function (response) {
      context.commit('GET_HOLIDAYS', response.data)
    })
  },
  get_deleted_holidays (context) {
    Axios.get(holidayUrls.getDeletedHoliday).then(function (response) {
      context.commit('GET_DELETED_HOLIDAYS', response.data)
    })
  },
  get_holiday (context, publicId) {
    Axios.get(holidayUrls.getHoliday + publicId).then(function (response) {
      context.commit('GET_HOLIDAY', response.data)
    })
  },
  post_holiday (context, data) {
    Axios.post(holidayUrls.postHoliday, data).then(function () {
      context.dispatch('get_all_holidays')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_holiday (context, data) {
    Axios.post(holidayUrls.editHoliday, data).then(function () {
      context.dispatch('get_all_holidays')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_holiday (context, publicId) {
    Axios.get(holidayUrls.deleteHoliday + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_HOLIDAYS', response.data)
      router.push({
        name: 'Module.DeletedHolidays'
      })
    })
  },
  restoreHoliday (context, publicId) {
    Axios.get(holidayUrls.restoreHoliday + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_HOLIDAYS', response.data)
      router.push({
        name: 'Module.Holidays'
      })
    })
  }
}
